import { CtaButton } from "@/components/buttons";
import { JSX } from "react";

export const RedirectWidget = ({
  icon,
  text,
  href,
}: {
  icon: JSX.Element;
  text: string;
  href: string;
}) => {
  return (
    <div className="bg-white rounded-3xl flex flex-col justify-center items-center col-span-1 row-span-1 p-8">
      <div>{icon}</div>
      <div className="text-2xl font-semibold my-5">{text}</div>
      <CtaButton href={href} text={text} />
    </div>
  );
};
